export const findBestSize = (targetRatio, currentWidth, currentHeight) => {
  if (targetRatio === 1) {
    return { width: currentWidth, height: currentWidth };
  }

  if (targetRatio === currentHeight / currentWidth) {
    return { width: currentHeight, height: currentWidth };
  }

  let bestWidth = currentWidth;
  let bestHeight = currentHeight;
  let bestDifference = Math.abs(bestWidth / bestHeight - targetRatio);

  // 优先以 currentWidth 为基准查找符合比例的 height
  if (currentWidth) {
    for (let height = 256; height <= 1024; height++) {
      const currentDifference = Math.abs(currentWidth / height - targetRatio);
      if (currentDifference < bestDifference) {
        bestWidth = currentWidth;
        bestHeight = height;
        bestDifference = currentDifference;
      }
    }
  }

  // 如果未找到符合比例的 height，则以 currentHeight 为基准查找符合比例的 width
  if (currentHeight) {
    for (let width = 256; width <= 1024; width++) {
      const currentDifference = Math.abs(width / currentHeight - targetRatio);
      if (currentDifference < bestDifference) {
        bestWidth = width;
        bestHeight = currentHeight;
        bestDifference = currentDifference;
      }
    }
  }

  // 逐步递增 currentWidth 以查找符合比例的 height
  for (let width = currentWidth + 1; width <= 1024; width++) {
    for (let height = 256; height <= 1024; height++) {
      const currentDifference = Math.abs(width / height - targetRatio);
      if (currentDifference < bestDifference) {
        bestWidth = width;
        bestHeight = height;
        bestDifference = currentDifference;
      }
    }
  }

  // 逐步递减 currentWidth 以查找符合比例的 height
  for (let width = currentWidth - 1; width >= 256; width--) {
    for (let height = 256; height <= 1024; height++) {
      const currentDifference = Math.abs(width / height - targetRatio);
      if (currentDifference < bestDifference) {
        bestWidth = width;
        bestHeight = height;
        bestDifference = currentDifference;
      }
    }
  }

  return { width: bestWidth, height: bestHeight };
};

export const resizeWithMaxSize = (srcWidth, srcHeight, maxWidth = 1024, maxHeight = 1024) => {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
  return [Math.min(maxWidth, Math.ceil(srcWidth * ratio)), Math.min(maxHeight, Math.ceil(srcHeight * ratio))];
};

export const resizeWithMinSize = (srcWidth, srcHeight, minWidth = 256, minHeight = 256) => {
  const ratio = Math.max(minWidth / srcWidth, minHeight / srcHeight);
  return [Math.max(minWidth, Math.floor(srcWidth * ratio)), Math.max(minHeight, Math.floor(srcHeight * ratio))];
};

export const findBestSizeByReferenceSize = (srcWidth, srcHeight, maxSize = 1024) => {
  let width = srcWidth,
    height = srcHeight;

  if (width < 512 || height < 512) {
    [width, height] = resizeWithMinSize(srcWidth, srcHeight, 512, 512);
  }

  if (width > maxSize || height > maxSize) {
    [width, height] = resizeWithMaxSize(width, height, maxSize, maxSize);
  }

  width = Math.max(512, Math.min(maxSize, width));
  height = Math.max(512, Math.min(maxSize, height));

  return { width, height };
};

export const getGroupPosition = (children = []) => {
  const position = { left: Infinity, right: -Infinity, top: Infinity, bottom: -Infinity };
  children.forEach((el) => {
    const { x: left, y: top, width, height, scaleX, scaleY } = el;

    const right = left + width * scaleX;
    const bottom = top + height * scaleY;
    if (scaleX < 0) {
      if (right < position.left) position.left = right;
      if (left > position.right) position.right = left;
    } else {
      if (left < position.left) position.left = left;
      if (right > position.right) position.right = right;
    }
    if (scaleY < 0) {
      if (bottom < position.top) position.top = top + bottom;
      if (top > position.bottom) position.bottom = top;
    } else {
      if (top < position.top) position.top = top;
      if (bottom > position.bottom) position.bottom = bottom;
    }
  });
  return position;
};
